module.exports = __webpack_public_path__ + "public/images/overview/Kovalevski.6a050324523c18c5e46438e9c0127d20.png";